module.exports = __webpack_public_path__ + "static/media/edit.59093822.svg";